<template>
  <div class="page-main">
    <van-nav-bar
      class="nav-bar"
      fixed
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />    
    <div class="content">
      <van-tabs v-model="active" sticky @click="handleTabs">
        <van-tab title="文章">
          <Artice></Artice>
        </van-tab>
        <van-tab title="视频">
          <Video></Video>
        </van-tab>
      </van-tabs>       
    </div>   
  </div>
</template>

<script>
import Artice from './artice'
import Video from './video'
export default {
  name: 'articleList',
  components: { Artice, Video },
  data() {
    return {
      active: 0,
    }
  },
  created() {
    this.handleNav(this.$route.params.title)
  },
  methods: {
    handleNav(title) {
      switch (title) {
        case 'article':
          this.title = '文章'
          this.active = 0
          break;
        case 'video':
          this.title = '视频'
          this.active = 1
          break;

        default:
          break;
      }
    },
    handleTabs(i) {
      switch (i) {
        case 0:
          this.$router.replace({ name: 'articleList', params: { title: 'article' } })
          break;
        case 1:
          this.$router.replace({ name: 'articleList', params: { title: 'video' } })
          break;

        default:
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-bar {
  min-height: 46px;
}
.content {
  position: fixed;
  left: 0;
  right: 0;
  top: 46px;
  bottom: 0;
}
</style>

